<div [innerHTML]="sanitizedIcon"></div>
